<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtros
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="5"
          class="mb-md-0 mb-2"
        >
          <label>Cursos</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="cursoFilter"
            :options="cursoOptions"
            class="w-100"
            :reduce="val => val.id"
            label="nombre"
            @input="(val) => $emit('update:cursoFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="5"
          class="mb-md-0 mb-2"
        >
          <label>Modalidades</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="modalidadFilter"
            :options="modalidadOptions"
            class="w-100"
            :reduce="val => val.id"
            @input="(val) => $emit('update:modalidadFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Publicado</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    cursoFilter: {
      type: [String, null],
      default: null,
    },
    modalidadFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [Boolean, null],
      default: null,
    },
    cursoOptions: {
      type: Array,
      required: true,
    },
    modalidadOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
